// Core muy simple sin bundlers: registro + arranque
(function () {
  // ===== Dependencias globales =====
  window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


  // ===== Núcleo de la app =====
  const App = {
    modules: {},

    // Registrar módulos desde ficheros sueltos
    register(name, initFn) {
      this.modules[name] = initFn;
    },

    // Montar un módulo sobre un selector (sin tocar HTML)
    mount(name, selector, options = {}) {
      const init = this.modules[name];
      if (typeof init !== 'function') return console.warn(`[App] módulo "${name}" no registrado`);
      document.querySelectorAll(selector).forEach(el => init(el, options));
    },

    // Arranque general
    boot() {
      // Aquí “llamas a todos desde app.js”
      // Ejemplos:
      this.mount('accordion', '.js-accordion');
      this.mount('dropdown',  '.js-dropdown');
      this.mount('modal',     '[data-modal-root]');
    }
  };

  // Exponer de forma controlada
  window.App = App;

  document.addEventListener('DOMContentLoaded', () => {
    App.boot();
    console.log('Gulp OK');
  });
})(); 
